<template lang="pug">
  span
    template(v-if="currency == 'USD'")
      i.flag-icon.flag-icon-us.align-middle
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'THB'")
      i.flag-icon.flag-icon-th.align-middle
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'IDR'")
      i.flag-icon.flag-icon-id.align-middle
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'VND'")
      i.flag-icon.flag-icon-vn.align-middle
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'CNY'")
      i.flag-icon.flag-icon-cn.align-middle
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'HKD'")
      i.flag-icon.flag-icon-hk.align-middle
      span #[b {{ currency }} ]
    template(v-else)
      i.flag-icon.flag-icon-my.align-middle
      span #[b {{ currency }} ]
</template>

<script>
export default {
  props: {
    currency: ""
  }
}
</script>
